import { useEffect } from "react";
/**
 * Mostly für Mapmanipulationen wie setPaintProperty oder setLayoutProperty
 */
export default function Interactivities(props) {
    useEffect(() => {
        props.cuMap.setPolygons3dProperty(props.extrusion);
    }, [props.extrusion]);
    useEffect(() => {
        if (props.camera)
            props.cuMap.stableEaseTo(props.camera);
    }, [props.camera]);
    return null;
}
